define('modules/page_generator/collections/variant_collection',['require','exports','module','backbone','modules/editor/models/variant','env'],function(require, exports, module){
	"use strict";
	var Backbone = require("backbone"),
			Variant = require("modules/editor/models/variant"),
			config = require("env");

	module.exports = Backbone.Collection.extend({
		model: Variant,
		url: function(){
			return [config.apiHost, "pages", this.pageId, "variants"].join("/");
		},
		initialize: function(models, options){
			this.pageId = options.pageId;
		}
	});
});
